// no itx for this file

import Button from "./Button";
import { findUnusedButtonChannel } from "./findUnusedButtonChannel";
import { ChannelType, channelTypeInfo, electricalChannelType, isCablelessPlugChannelType } from "./ChannelType";
import ConnectableObject from "./ConnectableObject";

import Logger from "../Logger";
import ButtonChannel from "./ButtonChannel";
import Consumer from "./Consumer";
import Device from "./Device";
const logger = new Logger();

enum ConnectionRelation {
  OneToOne,
  OneToMany,
  ManyToOne,
  ManyToMany,
}

type AllowedClassAndChanneltypePartner = {
  className: string;
  channelTypes?: Array<ChannelType>;
};

type AllowedClassAndChanneltypeCombination = {
  rulename: string;
  a: AllowedClassAndChanneltypePartner;
  b: AllowedClassAndChanneltypePartner;
  connectionRelation: ConnectionRelation;
  equalChannelTypesAreAlwaysAllowed?: boolean;
};

export default class AllowedConections {
  private static forbiddenClassCombinations = [
    { a: "Scene", b: "Scene" },
    { a: "Channel", b: "Channel" },
    { a: "Channel", b: "Scene" },
    { a: "ButtonChannel", b: "Channel" },
    { a: "ButtonChannel", b: "ButtonChannel" },
    { a: "ButtonChannel", b: "Button" },
    { a: "Button", b: "Button" },
    { a: "Multiplexer", b: "Scene" },
    { a: "Multiplexer", b: "Channel" },
    { a: "Multiplexer", b: "Multiplexer" },
  ];

  public static allowedClassAndChanneltypeCombinations: Array<AllowedClassAndChanneltypeCombination> = [
    {
      rulename: "Channel-Consumer-Rollo",
      a: {
        className: "Channel",
        channelTypes: [ChannelType.Jalousie, ChannelType.Blind],
      },
      b: {
        className: "Consumer",
        channelTypes: [ChannelType.Jalousie, ChannelType.Blind],
      },
      connectionRelation: ConnectionRelation.ManyToOne, // because of switching the channels -> wen consumer has allready a channel but we would like to sort them, we have to allow the connection th another channel-> if connection is created the old connection to channel wil be deleted
      equalChannelTypesAreAlwaysAllowed: true,
    },

    {
      rulename: "Channel.Generic-Consumer",
      a: { className: "Channel", channelTypes: [ChannelType.Generic] },
      b: {
        className: "Consumer",
        channelTypes: [
          ChannelType.Switch,
          ChannelType.Dimmer,
          ChannelType.TuneableWhite,
          ChannelType.Rgb,
          // ChannelType.Rgbw,
          ChannelType.Blind,
          ChannelType.Jalousie,
          ChannelType.Lock,
        ],
      },
      connectionRelation: ConnectionRelation.OneToOne,
      equalChannelTypesAreAlwaysAllowed: true,
    },

    {
      rulename: "ButtonChannel.Generic-Consumer",
      a: { className: "ButtonChannel", channelTypes: [ChannelType.Generic] },
      b: {
        className: "Consumer",
        channelTypes: [
          ChannelType.Switch,
          ChannelType.StaircaseLight,
          ChannelType.Dimmer,
          ChannelType.TuneableWhite,
          ChannelType.Rgb,
          // ChannelType.Rgbw,
          ChannelType.Blind,
          ChannelType.Jalousie,
          ChannelType.Heating,
        ],
      },
      equalChannelTypesAreAlwaysAllowed: true,
      connectionRelation: ConnectionRelation.ManyToMany,
    },
    {
      /// all light channeltypes should be connectable among themself
      rulename: "ButtonChannel-Consumer-light",
      a: {
        className: "ButtonChannel",
        channelTypes: [
          ChannelType.Switch,
          ChannelType.StaircaseLight,
          ChannelType.Dimmer,
          ChannelType.Rgb,
          // ChannelType.Rgbw,
          ChannelType.TuneableWhite,
        ],
      },
      b: {
        className: "Consumer",
        channelTypes: [
          ChannelType.Switch,
          ChannelType.StaircaseLight,
          ChannelType.Dimmer,
          ChannelType.Rgb,
          // ChannelType.Rgbw,
          ChannelType.TuneableWhite,
        ],
      },
      equalChannelTypesAreAlwaysAllowed: true,
      connectionRelation: ConnectionRelation.ManyToMany,
    },
    {
      rulename: "ButtonChannel.2-Consumer.Heating",
      b: { className: "ButtonChannel", channelTypes: [ChannelType.TemperatureMeasurement] },
      a: {
        className: "Consumer",
        channelTypes: [ChannelType.Heating],
      },
      equalChannelTypesAreAlwaysAllowed: true,
      connectionRelation: ConnectionRelation.OneToMany,
    },
    {
      rulename: "ButtonChannel.3-Consumer.Heating",
      a: { className: "ButtonChannel", channelTypes: [ChannelType.TemperatureSetpoint] },
      b: {
        className: "Consumer",
        channelTypes: [ChannelType.Heating],
      },
      connectionRelation: ConnectionRelation.ManyToMany,
    },
    {
      rulename: "ButtonChannel.4-Consumer.Heating",
      a: { className: "ButtonChannel", channelTypes: [ChannelType.OperationMode] },
      b: {
        className: "Consumer",
        channelTypes: [ChannelType.Heating],
      },
      connectionRelation: ConnectionRelation.ManyToMany,
    },

    {
      rulename: "ButtonChannel.Blind-Jalousie",
      a: { className: "ButtonChannel", channelTypes: [ChannelType.Blind, ChannelType.Jalousie] },
      b: {
        className: "Consumer",
        channelTypes: [ChannelType.Blind, ChannelType.Jalousie],
      },
      connectionRelation: ConnectionRelation.ManyToMany,
    },

    {
      rulename: "Scene-Consumer",
      a: { className: "Scene" },
      b: {
        className: "Consumer",
        channelTypes: [
          ChannelType.Switch,
          ChannelType.StaircaseLight,
          ChannelType.Dimmer,
          ChannelType.TuneableWhite,
          ChannelType.Rgb,
          // ChannelType.Rgbw,
          ChannelType.Blind,
          ChannelType.Jalousie,
        ],
      },
      connectionRelation: ConnectionRelation.ManyToMany,
    },
    {
      rulename: "Scene-ButtonChannel",
      a: { className: "Scene" },
      b: {
        className: "ButtonChannel",
        channelTypes: [ChannelType.Scene, ChannelType.Generic],
      },
      connectionRelation: ConnectionRelation.OneToMany,
    },

    {
      rulename: "Consumer.Lock-Consumer",
      a: { className: "Consumer", channelTypes: [ChannelType.Lock] },
      b: { className: "Consumer", channelTypes: [ChannelType.Jalousie, ChannelType.Blind] },
      connectionRelation: ConnectionRelation.ManyToMany,
    },

    {
      rulename: "Multiplexer.Generic-Consumer",
      a: { className: "Multiplexer", channelTypes: [ChannelType.Generic] },
      b: {
        className: "Consumer",
        channelTypes: [
          ChannelType.Switch,
          ChannelType.StaircaseLight,
          ChannelType.Dimmer,
          ChannelType.TuneableWhite,
          ChannelType.Rgb,
          // ChannelType.Rgbw,
          ChannelType.Blind,
          ChannelType.Jalousie,
          ChannelType.Heating,
        ],
      },
      connectionRelation: ConnectionRelation.ManyToMany,
    },
    {
      rulename: "Multiplexer.Generic-ButtonChannel",
      a: { className: "Multiplexer", channelTypes: [ChannelType.Generic] },
      b: {
        className: "ButtonChannel",
        channelTypes: [
          ChannelType.Switch,
          ChannelType.StaircaseLight,
          ChannelType.Dimmer,
          ChannelType.TuneableWhite,
          ChannelType.Rgb,
          // ChannelType.Rgbw,
          ChannelType.Blind,
          ChannelType.Jalousie,
          ChannelType.Heating,
        ],
      },
      connectionRelation: ConnectionRelation.OneToMany,
      equalChannelTypesAreAlwaysAllowed: true,
    },
    {
      rulename: "Multiplexer-ButtonChannel-Heating",
      a: {
        className: "Multiplexer",
        channelTypes: [ChannelType.Heating, ChannelType.TemperatureSetpoint, ChannelType.TemperatureMeasurement],
      },
      b: {
        className: "ButtonChannel",
        channelTypes: [ChannelType.Heating, ChannelType.TemperatureSetpoint, ChannelType.TemperatureMeasurement],
      },
      connectionRelation: ConnectionRelation.OneToMany,
      equalChannelTypesAreAlwaysAllowed: true,
    },
    {
      rulename: "Multiplexer-Consumer-Heating",
      a: {
        className: "Multiplexer",
        channelTypes: [ChannelType.Heating, ChannelType.TemperatureSetpoint, ChannelType.TemperatureMeasurement],
      },
      b: {
        className: "Consumer",
        channelTypes: [ChannelType.Heating, ChannelType.TemperatureSetpoint, ChannelType.TemperatureMeasurement],
      },
      connectionRelation: ConnectionRelation.ManyToMany,
      equalChannelTypesAreAlwaysAllowed: true,
    },
    {
      rulename: "Multiplexer-ButtonChannel-Light",
      a: {
        className: "Multiplexer",
        channelTypes: [
          ChannelType.Switch,
          ChannelType.StaircaseLight,
          ChannelType.Dimmer,
          ChannelType.TuneableWhite,
          ChannelType.Rgb,
        ],
      },
      b: {
        className: "ButtonChannel",
        channelTypes: [
          ChannelType.Switch,
          ChannelType.StaircaseLight,
          ChannelType.Dimmer,
          ChannelType.TuneableWhite,
          ChannelType.Rgb,
        ],
      },
      connectionRelation: ConnectionRelation.OneToMany,
      equalChannelTypesAreAlwaysAllowed: true,
    },
    {
      rulename: "Multiplexer-Consumer-Light",
      a: {
        className: "Multiplexer",
        channelTypes: [
          ChannelType.Switch,
          ChannelType.StaircaseLight,
          ChannelType.Dimmer,
          ChannelType.TuneableWhite,
          ChannelType.Rgb,
          ChannelType.Rgb,
        ],
      },
      b: {
        className: "Consumer",
        channelTypes: [
          ChannelType.Switch,
          ChannelType.StaircaseLight,
          ChannelType.Dimmer,
          ChannelType.TuneableWhite,
          ChannelType.Rgb,
          ChannelType.Rgb,
        ],
      },
      connectionRelation: ConnectionRelation.ManyToMany,
      equalChannelTypesAreAlwaysAllowed: true,
    },
    {
      rulename: "Multiplexer-ButtonChannel-Rollo",
      a: {
        className: "Multiplexer",
        channelTypes: [ChannelType.Jalousie, ChannelType.Blind],
      },
      b: {
        className: "ButtonChannel",
        channelTypes: [ChannelType.Jalousie, ChannelType.Blind],
      },
      connectionRelation: ConnectionRelation.OneToMany,
      equalChannelTypesAreAlwaysAllowed: true,
    },
    {
      rulename: "Multiplexer-Consumer-Rollo",
      a: {
        className: "Multiplexer",
        channelTypes: [ChannelType.Jalousie, ChannelType.Blind],
      },
      b: {
        className: "Consumer",
        channelTypes: [ChannelType.Jalousie, ChannelType.Blind],
      },
      connectionRelation: ConnectionRelation.ManyToMany,
      equalChannelTypesAreAlwaysAllowed: true,
    },
    {
      rulename: "Multiplexer-ButtonChannel-Generic",
      a: {
        className: "Multiplexer",
        channelTypes: [
          ChannelType.Heating,
          ChannelType.TemperatureSetpoint,
          ChannelType.TemperatureMeasurement,
          ChannelType.Switch,
          ChannelType.StaircaseLight,
          ChannelType.Dimmer,
          ChannelType.TuneableWhite,
          // ChannelType.Rgbw,
          ChannelType.Rgb,
          ChannelType.Jalousie,
          ChannelType.Blind,
        ],
      },
      b: {
        className: "ButtonChannel",
        channelTypes: [ChannelType.Generic],
      },
      connectionRelation: ConnectionRelation.OneToMany,
      equalChannelTypesAreAlwaysAllowed: true,
    },
    {
      rulename: "ButtonChannel-Consumer",
      a: {
        className: "ButtonChannel",
        channelTypes: [ChannelType.StatusDisplaySwitch],
      },
      b: {
        className: "Consumer",
        channelTypes: [
          ChannelType.Heating,
          ChannelType.TemperatureSetpoint,
          ChannelType.TemperatureMeasurement,
          ChannelType.Switch,
          ChannelType.StaircaseLight,
          ChannelType.Dimmer,
          ChannelType.TuneableWhite,
          // ChannelType.Rgbw,
          ChannelType.Rgb,
          ChannelType.Jalousie,
          ChannelType.Blind,
        ],
      },
      connectionRelation: ConnectionRelation.ManyToOne, // one status can only show one consumer
      equalChannelTypesAreAlwaysAllowed: false,
    },
  ];

  //
  //
  // hier prüfen wir ob die Classen von sourec und target überhaupt verbunden werden dürfen
  //
  private static checkClassCombinationsAllowed(source: ConnectableObject, target: ConnectableObject): boolean {
    for (let c of AllowedConections.forbiddenClassCombinations) {
      if (source.className == c.a && target.className == c.b) {
        return false;
      }
      if (source.className == c.b && target.className == c.a) {
        return false;
      }
    }

    return true;
  }

  //
  // für AutoConnect Button
  //

  private static checkAutoconnectButtonAllowedX(
    source: ConnectableObject,
    target: ConnectableObject,
    forNewConnection: boolean,
  ): boolean {
    let res = false;

    if (source.className == "Button") {
      const button = source as Button;

      //
      // Button  müssen einen LEEREN passenden ButtonChannel haben
      //
      button.buttonChannels.forEach((buttonChannel) => {
        if (buttonChannel.connections.size == 0 && !buttonChannel.isStatusChannel) {
          if (AllowedConections.isConnectionAllowed(buttonChannel, target, true)) {
            res = true;
          }
        }
      });
      if (!res) {
        //
        // Button  können sich dynamisch erweitern
        //
        const newButtonChannel = new ButtonChannel({}, undefined);
        newButtonChannel.channelType = ChannelType.Generic;

        if (AllowedConections.isConnectionAllowed(newButtonChannel, target, true)) {
          res = true;
        }
      }
    }

    return res;
  }

  private static checkAutoconnectButtonAllowed(
    source: ConnectableObject,
    target: ConnectableObject,
    forNewConnection: boolean,
  ): boolean {
    return (
      AllowedConections.checkAutoconnectButtonAllowedX(source, target, forNewConnection) ||
      AllowedConections.checkAutoconnectButtonAllowedX(target, source, forNewConnection)
    );
  }

  private static checkButtonChannelPartnerInAllowedChannelTypes(
    source: ConnectableObject,
    target: ConnectableObject,
    forNewConnection: boolean,
  ): boolean {
    //allowedChannelTypes
    let res = false;

    if (source.isButtonChannel) {
      let buttonChannel = source as ButtonChannel;

      buttonChannel.allowedChannelTypes?.forEach(({ channelType, text }) => {
        if (
          AllowedConections.checkAllowedClassAndChanneltypeCombinationsInOneDirection(
            buttonChannel,
            channelType,
            target,
            target.channelType,
            forNewConnection,
          ) ||
          AllowedConections.checkAllowedClassAndChanneltypeCombinationsInOneDirection(
            target,
            target.channelType,
            buttonChannel,
            channelType,
            forNewConnection,
          )
        ) {
          res = true;
          return;
        }
      });
    }
    return res;
  }

  private static getCountConnection(
    obj: ConnectableObject,
    equalChannelTypesAreAlwaysAllowed: boolean | undefined,
    itemPartner: AllowedClassAndChanneltypePartner,
  ) {
    const partnerClassName = itemPartner.className;
    const partnerChannelTypes = itemPartner.channelTypes;

    const res = obj.connections.findAsArray((con) => {
      const partner = con.getPartner(obj);
      const classNameIsEqual = partner?.className == partnerClassName;

      if (classNameIsEqual) {
        let channeltypeMatch = false;
        if (equalChannelTypesAreAlwaysAllowed) {
          if (obj.channelType == partner.channelType) {
            channeltypeMatch = true;
          }
        }

        if (!channeltypeMatch) {
          channeltypeMatch = partnerChannelTypes == undefined || partnerChannelTypes?.includes(partner.channelType);
        }

        return channeltypeMatch;
      }
      return false;
    });
    return res.length;
  }

  private static checkAllowedClassAndChanneltypeCombinationsInOneDirection(
    source: ConnectableObject,
    sourceChannelType: ChannelType,

    target: ConnectableObject,
    targetChannelType: ChannelType,

    forNewConnection: boolean,
  ): boolean {
    for (let item of AllowedConections.allowedClassAndChanneltypeCombinations) {
      if (source.className == item.a.className && target.className == item.b.className) {
        let ok = false;

        //
        // Source and Target channelTypes are equal
        //
        if (item.equalChannelTypesAreAlwaysAllowed) {
          if (sourceChannelType == targetChannelType) {
            ok = true;
          }
        }

        //
        // if Source and Target channelTypes are NOT equal. or EQUAL is not allowed in all cases
        // we check the channelType match in detail
        //
        //
        if (!ok) {
          const okA = item.a.channelTypes == undefined || item.a.channelTypes.includes(sourceChannelType);
          const okB = item.b.channelTypes == undefined || item.b.channelTypes.includes(targetChannelType);
          ok = okA && okB;
        }

        if (ok) {
          const countSource = AllowedConections.getCountConnection(
            source,
            item.equalChannelTypesAreAlwaysAllowed,
            item.b,
          );

          const countTarget = AllowedConections.getCountConnection(
            target,
            item.equalChannelTypesAreAlwaysAllowed,
            item.a,
          );

          switch (item.connectionRelation) {
            case ConnectionRelation.OneToOne: {
              if (forNewConnection) {
                return countTarget == 0 && countSource == 0;
              } else {
                return countTarget <= 1 && countSource <= 1;
              }
            }
            case ConnectionRelation.ManyToMany: {
              return true;
            }

            case ConnectionRelation.OneToMany: {
              if (forNewConnection) {
                return countTarget == 0;
              } else {
                return countTarget <= 1;
              }
            }

            case ConnectionRelation.ManyToOne: {
              if (forNewConnection) {
                return countSource == 0;
              } else {
                return countSource <= 1;
              }
            }
          }
        }
      }
    }

    return false;
  }

  private static checkAllowedClassAndChanneltypeCombinations(
    source: ConnectableObject,
    target: ConnectableObject,
    forNewConnection: boolean,
  ): boolean {
    let res = false;

    return (
      AllowedConections.checkAllowedClassAndChanneltypeCombinationsInOneDirection(
        source,
        electricalChannelType(source.channelType),
        target,
        electricalChannelType(target.channelType),
        forNewConnection,
      ) ||
      AllowedConections.checkAllowedClassAndChanneltypeCombinationsInOneDirection(
        target,
        electricalChannelType(target.channelType),
        source,
        electricalChannelType(source.channelType),
        forNewConnection,
      )
    );
  }

  private static checkforHeatingChannels(source: ConnectableObject, target: ConnectableObject): boolean {
    let res = false;
    const sourceChanneltypeInfo = channelTypeInfo(source.channelType);
    const targetChanneltypeInfo = channelTypeInfo(target.channelType);
    if (
      sourceChanneltypeInfo.temperatureAndHeatingChannelTypes &&
      targetChanneltypeInfo.temperatureAndHeatingChannelTypes
    ) {
      res = true;
    }

    return res;
  }

  static isAlreadyConnected(source: ConnectableObject, target: ConnectableObject): boolean {
    //
    // check if connection between source and target already exist
    //
    if (
      source.connections.getByPropertyValue("fromId", target.id) ||
      source.connections.getByPropertyValue("toId", target.id)
    ) {
      return true;
    }

    return false;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //
  // The main checking function
  //
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////

  static isConnectionAllowed(
    source: ConnectableObject,
    target: ConnectableObject,
    forNewConnection: boolean,
    rule?: "hard" | "soft",
  ): boolean {
    logger.log(`isConnectionAllowed ${source.tag} with ${target.tag} ...`);
    if (isCablelessPlugChannelType(source.channelType) || isCablelessPlugChannelType(target.channelType)) return false;

    // Check before auto-assignment and equal-type shortcuts: a spare key does not make
    // permanent power outlets, LAN etc. controllable by a button.
    const buttonConsumer = (source.className === "Button" || source.isButtonChannel) && target.isConsumer ? target
      : (target.className === "Button" || target.isButtonChannel) && source.isConsumer ? source : undefined;
    if (buttonConsumer && !channelTypeInfo(buttonConsumer.channelType).canBeConnectedWithButtonChannel) return false;

    if (forNewConnection && AllowedConections.isAlreadyConnected(source, target)) {
      return false;
    }
    if (forNewConnection && source.className === "Button" && target.isConsumer) {
      return !!findUnusedButtonChannel(source as Button, target);
    }
    if (forNewConnection && target.className === "Button" && source.isConsumer) {
      return !!findUnusedButtonChannel(target as Button, source);
    }

    // LAN consumers may only connect to actor channels
    if (channelTypeInfo(source.channelType).isLan || channelTypeInfo(target.channelType).isLan) {
      const isActorChannelPair =
        (source.isActorChannel && target.isConsumer) || (target.isActorChannel && source.isConsumer);
      if (!isActorChannelPair) {
        return false;
      }
    }
    //
    // mwe todo 28.8.2024:
    //   show be fine tuned somehow
    //
    if (source.className == target.className) {
      if (source.className == "Consumer") {
        // dont allow any via connection with lan
        if (channelTypeInfo(source.channelType).isLan || channelTypeInfo(target.channelType).isLan) {
          return false;
        }
        // allow lock rollo/jal Connections
        if (
          (source.channelType == ChannelType.Lock && channelTypeInfo(target.channelType)?.isRollo) ||
          (target.channelType == ChannelType.Lock && channelTypeInfo(source.channelType)?.isRollo)
        ) {
          return true;
        }
        return AllowedConections.isConnectionForTerminalViaConnectionsAllowed(source, target);
      }
      return false;
    }

    //
    // ok = die Verbinung zwischen source und Target ist bzgl der Klassen grundsätzlich erlaubt
    //
    let ok = AllowedConections.checkClassCombinationsAllowed(source, target);

    // check here for dali connection
    if (ok) {
      // only for via connections and ActorChannelConnections
      if (
        (source.isConsumer && target.isConsumer) ||
        (source.isActorChannel && target.isConsumer) ||
        (source.isConsumer && target.isActorChannel)
      ) {
        const channel = source.isActorChannel ? source : target.isActorChannel ? target : undefined;
        if (channel) {
          ok =
            (channel.parent as Device)?.isDali == source.isDali && (channel.parent as Device)?.isDali == target.isDali;
        } else {
          // consumer consumer connection
          ok = !source.isDali && !target.isDali;
        }
      }
    }
    if (ok && (source.isActorChannel || target.isActorChannel) && (source.isConsumer || target.isConsumer)) {
      ok =
        electricalChannelType(source.channelType) == electricalChannelType(target.channelType) ||
        (channelTypeInfo(source.channelType)?.isLight && channelTypeInfo(target.channelType)?.isLight) ||
        (channelTypeInfo(source.channelType)?.isRollo && channelTypeInfo(target.channelType)?.isRollo) ||
        (channelTypeInfo(source.channelType)?.isLan && channelTypeInfo(target.channelType)?.isLan) ||
        source.channelType == ChannelType.Generic ||
        target.channelType == ChannelType.Generic;
    }

    if (forNewConnection && AllowedConections.checkAutoconnectButtonAllowed(source, target, forNewConnection) && ok) {
      logger.log(` ==> checkAutoconnectButtonAllowed`);
      return true;
    }

    if (ok) {
      if (rule == "soft") {
        return true;
      }
      if (AllowedConections.checkAllowedClassAndChanneltypeCombinations(source, target, forNewConnection)) {
        // for Multiplexer

        logger.log(` ==> checkAllowedClassAndChanneltypeCombinations`);
        if (source.isMultiplexer || target.isMultiplexer) {
          return AllowedConections.checkSpecialRulesMultiplexer(source, target, forNewConnection);
        }
        return true;
      }

      // for channel consumer connection, to change actor channel
      if ((source.isChannel && target.isConsumer) || (target.isChannel && source.isConsumer)) {
        const channel = source.isChannel ? source : target;
        const consumer = source.isConsumer ? source : target;
        // schon eine verbindung vorhanden -> nicht erlaubt, ausser es ist genau die verbindung zwischen diesem channel und consumer
        // (sonst wuerde eine bereits bestehende, gueltige Verbindung bei checkForbidden faelschlicherweise als forbidden erkannt)
        const hasOtherConnection = channel.connections.findAsArray((c) => c.getPartner(channel) != consumer).length > 0;
        if (channel.isActorChannel && hasOtherConnection) {
          return false;
        }
        if (channel.channelType == ChannelType.Generic) {
          return true;
        } else if (
          (channelTypeInfo(channel.channelType)?.isLight && channelTypeInfo(consumer.channelType)?.isLight) ||
          (channelTypeInfo(channel.channelType)?.isHeating && channelTypeInfo(consumer.channelType)?.isHeating) ||
          (channelTypeInfo(channel.channelType)?.isRollo && channelTypeInfo(consumer.channelType)?.isRollo) ||
          (channelTypeInfo(channel.channelType)?.isLan && channelTypeInfo(consumer.channelType)?.isLan)
        ) {
          return true;
        }
      }

      if (
        (source.isButton || target.isButton) &&
        forNewConnection &&
        !channelTypeInfo(source.channelType)?.isSupply &&
        source.channelType != ChannelType.Lock &&
        target.channelType != ChannelType.Lock &&
        !channelTypeInfo(source.channelType).isLan &&
        !channelTypeInfo(target.channelType).isLan
      ) {
        return true;
      }

      // check here if buttonChannel is customizable
      if (
        (source.isButtonChannel && source.connections.size == 0) ||
        (target.isButtonChannel && target.connections.size == 0)
      ) {
        return (
          AllowedConections.checkButtonChannelPartnerInAllowedChannelTypes(source, target, forNewConnection) ||
          AllowedConections.checkButtonChannelPartnerInAllowedChannelTypes(target, source, forNewConnection)
        );
      }
    }

    return false;
  }
  static isConnectionForTerminalViaConnectionsAllowed(source: ConnectableObject, target: ConnectableObject): boolean {
    if (source.className == "Consumer" && target.className == "Consumer") {
      // Lock consumer have a 24V supply/actor
      if (source.isDali || target.isDali) {
        return false;
      }

      if (
        (source.channelType == ChannelType.Lock && target.channelType != ChannelType.Lock) ||
        (source.channelType != ChannelType.Lock && target.channelType == ChannelType.Lock)
      ) {
        return false;
      }
      // 400V not with 230V
      if (
        (source.channelType == ChannelType.suply400V && target.channelType != ChannelType.suply400V) ||
        (source.channelType != ChannelType.suply400V && target.channelType == ChannelType.suply400V)
      ) {
        return false;
      }
      // 230V not with 24V or 12V
      if (
        (source.channelType == ChannelType.suply12V && target.channelType != ChannelType.suply12V) ||
        (target.channelType == ChannelType.suply12V && source.channelType != ChannelType.suply12V)
      ) {
        return false;
      }
    } else {
      return false;
    }
    // check if target consumer is a viaconsumer
    if ((target as Consumer).getTerminalViaConsumer()) {
      return false;
    }
    // check if source consumer has via consumer/s
    if ((source as Consumer).getIncommingTerminalViaConsumers().length > 0) {
      return false;
    }

    return true;
  }
  static checkSpecialRulesMultiplexer(
    source: ConnectableObject,
    target: ConnectableObject,
    forNewConnection: boolean,
  ): boolean {
    let res = true;
    const buttonChannel = target.className == "ButtonChannel" ? target : source;
    const partner = target.className != "ButtonChannel" ? target : source;
    if (buttonChannel.className == "ButtonChannel") {
      if (partner.className == "Multiplexer") {
        // check if buttonChannelhas no connection for connection with Multiplexer
        if (forNewConnection) {
          return buttonChannel.connections.size == 0;
        } else {
          return buttonChannel.connections.size == 1;
        }
      } else if (partner.className == "Consumer") {
        // check if multiplexer allready connected with buttonChannel
        buttonChannel.connections.forEach((con) => {
          let conp = con.getMultiplexer();
          if (conp?.className == "Multiplexer") {
            res = false;
          }
        });
      }
    }
    return res;
  }
}
